import React, { Component } from "react";
import { Row, Col, Alert, Button ,Container, FormGroup, Label } from "reactstrap";

// Redux
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// action
import { forgetUser } from '../../store/actions';

// import images
//import logodark from "../../assets/images/logo-dark.png";

class ForgetPasswordPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
        stage : 1,
        email: "",
        verificationCode: "",
        newPassword: null,
        confirmPassword: null,
        validPassword: true
    };

    // handleValidSubmit
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
    this.handleValidSubmit1 = this.handleValidSubmit1.bind(this);
  }

  changeState = (e) => {
      this.setState({
          [e.target.id]: e.target.value
      })
  }

  // handleValidSubmit
  handleValidSubmit(event, values) {
    this.setState({
        stage: 2
    })
    this.props.forgetUser(values, this.props.history);
  }

  handleValidSubmit1(event, values) {
        this.setState({
            validPassword: true
        })
        values["username"] = this.state.email
        this.props.forgetUser(values, this.props.history, this.state.email);
      
        this.setState({
            validPassword: false
        })
  }

  tryAgain = () => {
    this.props.forgetUser({username: this.state.email}, this.props.history);
  }

  render() {
    return (
        <React.Fragment>
        <div className="home-btn d-none d-sm-block">
             <Link to="/"><i className="mdi mdi-home-variant h2 text-white"></i></Link>
         </div>
         <div>
             <Container fluid className="p-0">
                 <Row className="no-gutters">
                     <Col lg={4}>
                         <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                             <div className="w-100">
                                 <Row className="justify-content-center">
                                     <Col lg={9}>
                                         <div>
                                             <div className="text-center">
                                                 <div>
                                                    <Link to="/" className="logo"><h1 className="font-size-35 mt-4">UTJD</h1></Link>
                                                 </div>
     
                                                 <h4 className="font-size-18 mt-4">Reset Password</h4>
                                                 <p className="text-muted">Reset your password to UTJD.</p>
                                             </div>
                                             
                                             { this.state.stage === 1 && (
                                                 <div className="p-2 mt-5">
                                             
                                                 <Alert color="info" className="mb-4">Enter your Email</Alert>
                                             
                                                  
                                                 <AvForm className="form-horizontal" onValidSubmit={this.handleValidSubmit}>
                     
                                                     <FormGroup className="auth-form-group-custom mb-4">
                                                         <i className="ri-mail-line auti-custom-input-icon"></i>
                                                         <Label for="useremail">Email</Label>
                                                         <AvField name="username" id="email" type="email" value={this.state.email} validate={{email: true, required: true}} className="form-control" onChange={this.changeState} placeholder="Enter email"/>
                                                     </FormGroup>
 
                                                     <div className="mt-4 text-center">
                                                         <Button color="primary" className="w-md waves-effect waves-light" type="submit">Send</Button>
                                                     </div>
                                                 </AvForm>
                                                 </div>
                                             )}
                                             { this.state.stage === 2 && (

                                                 <div className="p-2 mt-5">
                                                 <Alert color="info" className="mb-4">Fill in verification code from your email and a new password</Alert>
                                                 
                                                {this.props.forgetError && this.props.forgetError ?
                                                <Alert color="danger" className="mb-4">{this.props.forgetError}</Alert> : null }
                                                {
                                                this.props.message ? 
                                                <Alert color="success" className="mb-4">Password Successfully changed!</Alert> : null
                                                }
                                                 
                                                 <AvForm className="form-horizontal" onValidSubmit={this.handleValidSubmit1} >
                     
                                                     <FormGroup className="auth-form-group-custom mb-4">
                                                         <i className="ri-mail-line auti-custom-input-icon"></i>
                                                         <Label for="useremail">Verification Code</Label>
                                                         <AvField name="verification" type="text" errorMessage="Enter verification code"
                                                            validate={{ required: { value: true } }} value={this.state.verificationCode} className="form-control" id="verification" placeholder="Code"/>
                                                     </FormGroup>
 
                                                     <FormGroup className="auth-form-group-custom mb-4">
                                                         <i className="ri-lock-2-line auti-custom-input-icon"></i>
                                                         <Label htmlFor="userpassword">New Password</Label>
                                                         <AvField name="newPassword" value={this.state.newPassword} 
                                                            errorMessage="Enter password"
                                                            validate={{ required: { value: true } }}
                                                            type="password" className="form-control" onChange={this.changeState} id="newPassword" placeholder="Password"/>
                                                     </FormGroup>
 
                                                     <FormGroup className="auth-form-group-custom mb-4">
                                                         <i className="ri-lock-2-line auti-custom-input-icon"></i>
                                                         <Label htmlFor="userpassword">Confirm Password</Label>
                                                         <AvField name="confirmPassword" value={this.state.confirmPassword}
                                                            errorMessage="Enter password again"
                                                            validate={{ required: { value: true }, match: { value: "newPassword" }}}
                                                          type="password" className="form-control" onChange={this.changeState} id="confirmPassword" placeholder="Password"/>
                                                     </FormGroup>
                                                     <p>Did not receive verification code? <Link className="font-weight-medium text-primary" onClick={this.tryAgain}>Try again</Link></p>
                                                     <div className="mt-4 text-center">
                                                         <Button color="primary" className="w-md waves-effect waves-light" type="submit">Reset</Button>
                                                     </div>
                                                 </AvForm>
                                                 </div>
                                                 )}
                                                 
                                             
 
                                             <div className="mt-5 text-center">
                                                 <p>Don't have an account ? <Link to="/auth-login" className="font-weight-medium text-primary"> Log in </Link> </p>
                                                 <p>© 2020 UTJD. Crafted with <i className="mdi mdi-heart text-danger"></i> by 2Students1Master</p>
                                             </div>
                                         </div>
 
                                     </Col>
                                 </Row>
                             </div>
                         </div>
                     </Col>
                     <Col lg={8}>
                         <div className="authentication-bg">
                             <div className="bg-overlay"></div>
                         </div>
                     </Col>
                 </Row>
             </Container>
         </div>
       </React.Fragment>
    );
  }
}

const mapStatetoProps = state => {
  const { message, forgetError, loading } = state.Forget;
  return { message, forgetError, loading };
}

export default withRouter(
  connect(mapStatetoProps, { forgetUser })(ForgetPasswordPage)
);
